import { Empty } from 'antd';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getAccess, log } from 'utils';
import {
  bulkInformation,
  deleteInformation,
  fetchInformation,
} from 'state/actions/information';
// import { regexInput } from 'utils/regex';
// import Table from 'components/Table';
import _ from 'underscore';
import { EmptyIcon } from 'assets/icon/bigicon';
import { FilterIcon } from 'assets/icon';
import ModalInformationCategoryForm from 'components/ModalInformationCategoryForm';
import {
  createInformationCategory,
  deleteInformationCategory,
  fetchInformationCategories,
  modifyInformationCategory,
  setInformationCategory,
} from 'state/actions/informationCategories';
import ModalDelete from 'components/ModalDelete';
import Cards from 'design-components/Cards';
import CategoryDropdown from 'components/CategoryDropdown';
import './Information.scss';
import './Information.css';
import { setInfoCategory, setTabInformation } from '../../state/actions/breadcrumb';

const Information = ({ history }) => {
  const { siteId, siteName } = useParams();

  const {
    informationList,
    informationCategories,
    loading,
    selectedTab,
    userData,
    role,
    updated,
    category,
    selectedCategory,
    categoryLoading,
  } = useSelector(
    (state) => ({
      informationList: state.information.list,
      informationCategories: state.informationCategories.list,
      selectedTab: state.breadcrumb.information,
      selectedCategory: state.breadcrumb.infoCategory,
      error: state.information.error,
      loading: state.information.loading,
      deleted: state.information.deleted,
      userData: state.auth.userData,
      updated: state.information.updated,
      role: state.auth.userData.role,
      category: state.informationCategories.category,
      categoryLoading: state.informationCategories.loading,
      informationData: state.information.information,
    }),
    shallowEqual
  );

  if (informationList) {
    log(informationList, '<<< infor list');
  }

  const [deleteModal, setDeleteModal] = useState({
    information: null,
    isOpen: false,
  });

  const dispatch = useDispatch();

  const [search, setSearch] = useState();
  const [tempSelectedCategory, setTempSelectedCategory] = useState(
    selectedCategory
  );
  const [playlistOpen, setPlaylistOpen] = useState(false);
   const [modalCategory, setModalCategory] = useState(false);
  const [dragDropElement, setDragDropElement] = useState({
    dragged: '',
    enter: '',
  });
  const [modalDeleteCategory, setModalDeleteCategory] = useState({
    show: false,
    category: null,
  });

  const [access, setAccess] = useState(null);

  const uid = userData.id;

  useEffect(() => {
    dispatch(setTabInformation('published'));
    dispatch(fetchInformation({ siteId, type:selectedTab, categoryId:selectedCategory }));
    dispatch(fetchInformationCategories({ siteId }));
    dispatch(setInfoCategory(selectedCategory));
  }, [siteId]); // eslint-disable-line

  useEffect(() => {
    dispatch(
      fetchInformation({
        siteId,
        categoryId: selectedCategory,
        type: selectedTab,
      })
    );
    // dispatch(fetchInformationCategories({ siteId }));
    // setMedias(mediaList);
  }, [selectedTab, selectedCategory]); // eslint-disable-line

  useEffect(() => {
    log(updated);
    if (updated && !loading) {
      dispatch(fetchInformation({ siteId, type:selectedTab, categoryId:selectedCategory }));
    }
  }, [updated, loading]); // eslint-disable-line

  useEffect(() => {
    if (userData && userData.roleAccess) {
      setAccess(getAccess(userData, 'tenant', siteId));
    }
  }, [userData, siteId]);

  const onRemoveButtonClickHandler = (information) => {
    setDeleteModal({
      information,
      isOpen: true,
    });
  };

  const onCloseModalHandler = () => {
    setDeleteModal({ information: null, isOpen: false });
  };

  const onDeleteInformationHandler = () => {
    dispatch(
      deleteInformation({ id: deleteModal.information, siteId }, () => {
        onCloseModalHandler();
      })
    );
  };

  // const onNewInformationHandler = () => {
  //   setInformation(defaultInformation);
  //   setIsEditing(false);
  //   setVisible(true);
  // };

  const handleSearch = (e) => {
    // setSearchError(null);
    // if (!regexInput(e.target.value) && e.target.value) {
    //   setSearchError('Search cannot using special character');
    // }
    console.log(e.target.value);
    setSearch(e.target.value);
  };

  const dataByCategory = informationList.filter((information) => {
    return selectedCategory !== 'all'
      ? information.categoryId === selectedCategory
      : true;
  });

  const filteredData = search
    ? dataByCategory.filter((el) => {
        const clonedElem = { ...el };
        return clonedElem.name.toLowerCase().includes(search.toLowerCase());
      })
    : dataByCategory;

  // const confirmMessage = useFormatMessage('Information.confirm');

  // const permDeleteMessage = useFormatMessage('Information.permDelete');

  const getCategory = (categoryId) => {
    const findCategory = informationCategories.find(
      (cat) => cat._id === categoryId
    );
    return findCategory?.name;
  };

  const handleSetPlaylist = () => {
    dispatch(setInfoCategory(tempSelectedCategory));
    setPlaylistOpen(false);
  };

  const handleEdit = (id) => {
    history.push(`/${siteId}/information/${siteName}/information/${id}`);
  };

  const onSubmitCategory = () => {
    const action = category._id
      ? modifyInformationCategory
      : createInformationCategory;

    dispatch(
      action({ uid, ...category, siteId, id: category._id }, () =>
        setModalCategory(false)
      )
    );
  };

  const handleSetCategory = (data) => {
    dispatch(setInformationCategory(data));
  };

  const handleEditCategory = (category) => {
    // setIsEditing(true);
    dispatch(setInformationCategory(category));
    setModalCategory(true);
  };

  const handleDeleteCategory = (category) => {
    setModalDeleteCategory({
      show: true,
      category,
    });
  };

  const onDeleteCategory = () => {
    dispatch(
      deleteInformationCategory(modalDeleteCategory.category._id, () =>
        onCloseModalCategoryHandler()
      )
    );
  };

  const onCloseModalCategoryHandler = () => {
    setModalDeleteCategory({
      show: false,
      category: null,
    });
  };

  const handleNew = () => {
    dispatch(
      setInformationCategory(
        {
          _id: '',
          name: '',
          description: '',
        },
        () => setModalCategory(true)
      )
    );
  };

  return (
    <div className="information-library">
      <ModalDelete
        isVisible={modalDeleteCategory.show}
        onOk={onDeleteCategory}
        onCancel={onCloseModalCategoryHandler}
        title="Delete Category"
        subtitle={
          modalDeleteCategory.category ? modalDeleteCategory.category.name : ''
        }
        loading={categoryLoading}
      />

      <ModalDelete
        isVisible={deleteModal.isOpen}
        onOk={onDeleteInformationHandler}
        onCancel={onCloseModalHandler}
        title="Delete Information"
        subtitle={deleteModal.information ? deleteModal.information.name : ''}
        loading={loading}
      />

      <ModalInformationCategoryForm
        visible={modalCategory}
        onCancel={() => {
          setModalCategory(false);
        }}
        onCreate={onSubmitCategory}
        category={category}
        setCategory={handleSetCategory}
        isEditing={!!category._id}
      />

      <div className="information-header">
        <div className="information-header-left">
          <div className="searchbar-wrapper">
            <div className="searchbar">
              <i className="feather-search" />
              <input
                placeholder="Search"
                className="search-input"
                // value={search}
                onChange={handleSearch}
              />
            </div>
          </div>
          <div
            className="playlist-wrapper"
            onClick={() => setPlaylistOpen(!playlistOpen)}
          >
            <div className="playlist-selection">
              <FilterIcon />
              <span>
                {selectedCategory === 'all'
                  ? 'Show All'
                  : getCategory(selectedCategory)}
              </span>
            </div>
            <i
              className={`feather-chevron-down ${
                playlistOpen ? 'playlist-open' : 'playlist-closed'
              }`}
            />

            <CategoryDropdown
              categories={informationCategories}
              setTempSelectedCategory={(id) => setTempSelectedCategory(id)}
              handleEditCategory={
                role === 'superadmin' ? (cat) => handleEditCategory(cat) : null
              }
              handleDeleteCategory={
                role === 'superadmin'
                  ? (cat) => handleDeleteCategory(cat)
                  : null
              }
              modalOpen={playlistOpen}
              handleSetPlaylist={handleSetPlaylist}
              tempSelectedCategory={tempSelectedCategory}
              handleNew={handleNew}
              filter
            />
            {/* <div
              className={`playlist-dropdown ${
                playlistOpen
                  ? 'playlist-dropdown-open'
                  : 'playlist-dropdown-closed'
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              <ul>
                <li className="header" onClick={handleNew}>
                  <i className="feather-plus" />
                  Add New Category
                </li>
                <li>
                  <div
                    className={`radio ${
                      tempSelectedCategory === 'all' ? 'active' : ''
                    }`}
                    onClick={() => setTempSelectedCategory('all')}
                  >
                    {tempSelectedCategory === 'all' && (
                      <div className="radio-checked" />
                    )}
                  </div>
                  Show All
                </li>

                {informationCategories.map((cat) => {
                  return (
                    <li key={cat._id}>
                      <div className="playlist-filter">
                        <div className="playlist-filter-radio">
                          <div
                            className={`radio ${
                              tempSelectedCategory === cat._id ? 'active' : ''
                            }`}
                            onClick={() => setTempSelectedCategory(cat._id)}
                          >
                            {tempSelectedCategory === cat._id && (
                              <div className="radio-checked" />
                            )}
                          </div>
                          {cat.name}
                        </div>
                        <Tooltip title="Options">
                          <Dropdown
                            trigger="click"
                            overlay={
                              <Menu>
                                <Menu.Item
                                  key="edit"
                                  onClick={() => handleEditCategory(cat)}
                                >
                                  <i className="feather-edit mr-2" />
                                  Edit
                                </Menu.Item>
                                <Menu.Divider />
                                <Menu.Item
                                  key="delete"
                                  onClick={() => handleDeleteCategory(cat)}
                                >
                                  <i className="feather-trash-2 mr-2" />
                                  Delete
                                </Menu.Item>
                              </Menu>
                            }
                          >
                            <button>
                              <i className="feather-more-horizontal" />
                            </button>
                          </Dropdown>
                        </Tooltip>
                      </div>
                    </li>
                  );
                })}
                <li className="playlist-button" onClick={handleSetPlaylist}>
                  Set Category
                </li>
              </ul>
            </div> */}
          </div>
        </div>
        <div className="actions__wrapper">
          {role !== 'superadmin' ? (
            access &&
            access.create && (
              <Link
                to={`/${siteId}/information/${siteName}/information/new`}
                className="btn-primary"
              >
                <i className="feather-plus mr-2" />
                New Information
              </Link>
            )
          ) : (
            <Link
              to={`/${siteId}/information/${siteName}/information/new`}
              className="btn-primary"
            >
              <i className="feather-plus mr-2" />
              New Information
            </Link>
          )}
        </div>
      </div>

      <div className="information-content-wrapper">
        <div className="information-content">
          <div className="information-tab-wrapper">
            <div className="information-tab-left">
              <div
                onClick={() => dispatch(setTabInformation('published'))}
                className={`information-tab ${
                  selectedTab === 'published' ? 'active' : ''
                }`}
              >
                Published Items
              </div>
              <div
                onClick={() => dispatch(setTabInformation('unpublished'))}
                className={`information-tab ${
                  selectedTab === 'unpublished' ? 'active' : ''
                }`}
              >
                Unpublished Items
              </div>
              <div
                onClick={() => dispatch(setTabInformation('archived'))}
                className={`information-tab ${
                  selectedTab === 'archived' ? 'active' : ''
                }`}
              >
                Archived Items
              </div>
            </div>
            </div>
          <div className="information-list-content">
            {informationList.length > 0 && filteredData.length > 0 ? (
              _.chunk(filteredData, 3).map((chunk, index) => {
                return (
                  <div className="information-list-chunk" key={index}>
                    {chunk.map((information) => {
                      return (
                        <div
                          key={information._id}
                          data-id={information._id}
                          className={`information-list ${
                            dragDropElement.dragged === information._id
                              ? 'dragged'
                              : ''
                          } ${
                            dragDropElement.enter === information._id
                              ? 'entered'
                              : ''
                          }`}
                          draggable
                          onDragStart={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: information._id,
                            })
                          }
                          onDragEnd={() =>
                            setDragDropElement({
                              ...dragDropElement,
                              dragged: '',
                            })
                          }
                          onDragEnter={() => {
                            setDragDropElement({
                              ...dragDropElement,
                              enter: information._id,
                            });
                          }}
                          onDragOver={(e) => {
                            e.preventDefault();
                            return false;
                          }}
                          onDrop={(e) => {
                            e.stopPropagation();
                            const findInfo = informationList.find(
                              (info) => info._id === dragDropElement.dragged
                            );
                            const sourceSequence = findInfo.sequence;
                            const newInfo = [...informationList];
                            const findSource = newInfo.find(
                              (x) => x._id === findInfo._id
                            );

                            if (findSource) {
                              findSource.sequence = information.sequence;
                            }

                            const findTarget = newInfo.find(
                              (x) => x._id === information._id
                            );

                            if (findTarget) {
                              findTarget.sequence = sourceSequence;
                            }
                            dispatch(
                              bulkInformation({
                                data: _.sortBy(newInfo, 'sequence'),
                                siteId,
                              })
                            );

                            setDragDropElement({
                              dragged: '',
                              enter: '',
                            });
                          }}
                        >
                          <Cards
                            data={information}
                            type="information"
                            isShowMedia
                            isShowinformation
                            editAction={() => handleEdit(information._id)}
                            deleteAction={() =>
                              onRemoveButtonClickHandler(information._id)
                            }
                          />
                        </div>
                      );
                    })}
                    {chunk.length < 2 && <div className="information-list-empty" />}
                    {chunk.length < 3 && <div className="information-list-empty" />}
                  </div>
                );
              })
            ) : (
              <div className="information-empty">
                <Empty image={EmptyIcon} description="No Information" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;
